import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    p2: {
      fill: "none",
      "fill-opacity": 1,
      stroke: "white",
      "stroke-width": 4.39474,
      "stroke-linecap": "butt",
      "stroke-linejoin": "round",
      "stroke-miterlimit": 4,
      "stroke-opacity": 1,
      "stroke-dasharray": 100,

      "-webkit-animation": "$load 6s infinite",
      animation: "$load 6s infinite",
    },
    p3: {
      fill: "none",
      "fill-opacity": 1,
      stroke: "yellow",
      "stroke-width": 1.55058,
      "stroke-miterlimit": 4,
      "stroke-dasharray": "none",
    },
    p4: {
      fill: "none",
      "fill-opacity": 1,
      stroke: "white",
      "stroke-width": 1.55058,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": 4,
      "stroke-opacity": 1,

      "stroke-dasharray": 100,
      "stroke-dashoffset": 20,
    },
    "@keyframes load": {
      "100%": {
        "stroke-dashoffset": 1000,
      },
    },
    back: {
      width: "100vw",
      height: "100vh",
      position: "absolute",
      background:
        "linear-gradient(162deg, rgba(215,65,119,1) 28%, rgba(255,233,138,1) 100%)",
      top: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);

export const Loader = () => {
  const classes = useStyles();
  console.log(JSON.stringify(classes));
  const logo = (
    <svg width="74mm" height="105mm" viewBox="0 0 74 105">
      <g id="layer1">
        <g
          id="g1655"
          transform="matrix(1.228265,0,0,1.228265,-15.688551,-2.8817635)"
        >
          <path
            className={classes.p2}
            d="M 42.887658,74.736681 60.831794,45.977789 C 66.923903,31.387039 58.290261,16.415982 42.532785,16.363714 25.969586,16.308785 18.927743,31.716674 24.775169,45.977789 Z"
            id="path843-6"
          />
          <g
            id="g949"
            className={classes.p3}
            transform="matrix(2.8342576,0,0,2.8342576,-103.21625,-18.060921)"
          >
            <path
              className={classes.p4}
              d="m 53.501161,23.707667 c 1.644134,-1.101723 2.597008,-2.178192 2.572219,-4.533452 -0.02287,-2.173019 -1.479467,-4.657733 -4.716057,-4.661369 -2.892703,-0.0033 -4.608919,2.312079 -4.538797,4.661369 0.08153,2.731346 1.88529,4.928724 4.650055,4.932905 v -2.793296 l -2.354336,-2.373407 2.373408,-2.354336 2.185097,2.346858 -0.863738,0.831218"
              id="path860-5"
            />
          </g>
        </g>
      </g>
    </svg>
  );
  return <div className={classes.back}>{logo}</div>;
};
